const translation = {
    confirm: '확실합니까?',
    common: { back: '뒤쪽에' },
    save: '저장',
    returnToGame: '게임에 다시 참여하시겠습니까?',
    yes: '예',
    no: '아니요',
    login: {
        auth: '권한 부여',
        noAcc: '계정 없음',
        reg: '등록하다',
        mail: '이메일로 로그인',
        registration: '등록',
        agreement: '"가입하기" 버튼을 클릭하면 개인 정보 처리에',
        agreementLink: '동의하는 것으로 간주됩니다.',
        submit: '등록하다',
        continue: '계속하기',
        emailLabel: '이메일',
        passwordLabel: '비밀번호',
        repeatPasswordLabel: '비밀번호를 반복하세요',
        loginButton: '로그인',
        logout: '로그 아웃',
        invalidEmail: '잘못된 이메일 형식',
        invalidFormatPassword: '잘못된 비밀번호 형식',
        forgotPassword: '비밀번호를 잊어 버렸습니까',
        passwordRecovery: '비밀번호 복구',
        passwordRecoveryTitle: '지정된 이메일로 편지를 보내드립니다.',
        sendLetter: '편지 보내기',
        userExists: '이 이메일을 가진 사용자가 존재합니다',
        userNotExists: '이 이메일을 사용하는 사용자가 존재하지 않습니다.',
        passwordResetToMail: '비밀번호 재설정 지침이 이메일로 전송되었습니다.',
        passwordValidation: '8~20자의 라틴 문자 또는 숫자를 포함해야 합니다.',
        invalidPassword: '잘못된 비밀번호',
        sessionNotFound: '세션을 찾을 수 없습니다',
        mismatchPassword: '암호 불일치! 다시 시도하십시오',
        rememberPassword: '비밀번호를 기억했습니다',
        restore: '복원하다',
        accExist: '계정을 갖고있다',
        confirmationCode: '이메일로 전송된 확인 코드를 입력하세요',
        code: '확인 코드',
        send: '보내다',
        confirmation: '확인하다',
        resend: '재전송',
        codeIsValid: '코드가 유효합니다',
        codeNotValid: '코드가 유효하지 않습니다',
        newPassword: '새 비밀번호를 입력하세요',
        passwordUsedBefore: '비밀번호는 이전에 이미 사용되었습니다',
        passwordUpdatedSuccessfully: '비밀번호가 성공적으로 업데이트되었습니다',
        enterEmail: '당신의 이메일 주소를 입력 해주세요',
        enterPassword: '암호를 입력',
        enterPasswordAgain: '비밀번호를 다시 입력하세요',
        enterAgreement: '개인 데이터 처리에 대한 동의를 확인하세요',
        notRobot: '로봇이 아님을 증명하십시오.',
        deletionPersonalData: '개인 데이터를 삭제하려면 이메일로 메시지를 보내주세요.',
    },
    profile: {
        edit: '프로필 수정',
        remove: '계정 삭제',
        projectName: '프로젝트 이름',
        editing: '프로필 편집',
        name: '당신의 이름',
        lastName: '당신의 성',
        inputPattern: '2글자부터 10글자까지',
        purchases: '구매가 없습니다',
        settings: '설정',
        transactions: '거래',
        support: '지원',
    },
    payment: {
        toPay: '지불하다',
        method: '결제수단',
        pay: '지불하다',
        purchases: '구매',
        paymentMethod: '결제수단',
        debitCard: '직불 카드',
        copy: '결제ID가 복사되었습니다!',
        cancellation: '정말로 결제를 취소하시겠습니까?',
        email: '영수증을 받기 위한 이메일',
        status: {
            none: '없음',
            pending: '대기 중',
            paid: '지불 됨',
            fail: '실패',
        },
        state: {
            progress: '지불 처리 중',
            wait: '잠시만 기다려 주세요',
            paid: '지불 완료',
            successful: '지불 성공',
            notPaid: '미지불',
            error: '오류',
            cancelled: '지불 취소',
            cancel: '취소',
        },
    },
    games: {
        header: {
            buttonGuest: '게스트',
            buttonLogin: '로그인',
            buttonLogout: '로그아웃',
        },
        buttonPlay: '플레이',
        buttonInDevelop: '개발 중',
    },
    support: {
        noPurchases: '아직 구매 내역이 없습니다',
        contactSupport: '지원팀에 문의하기',
        paymentId: '결제 ID',
        userId: '사용자 ID',
        requestReason: '문의 사유',
        feedbackEmail: '회신용 이메일',
        dropNotCredited: '드롭이 적립되지 않았습니다',
        other: '기타',
        success: '요청이 승인되었습니다',
        successText: '요청을 받았으며 곧 이메일로 연락드리겠습니다.',
        createTicket: '문의 생성',
        ticketTitle: '내 티켓',
        requestDescription: '문제에 대해 가급적 자세히 설명해 주세요',
        requestTitleDescription: '제목을 입력하세요',
        ticketTitlePlug: '에서의 요청',
        errorMessageFormat: '지원되지 않는 비디오 형식',
        errorMessageSize: '파일 크기가 제한을 초과했습니다',
        you: '당신',
        subject: '요청 주제',
        description: '설명',
        descriptionEmptyWarning: '문제 설명을 입력해주세요',
        conversationEnded: '대화가 종료되었습니다',
        system: '시스템 메시지',
        messageDelivered: '시스템에 의해 메시지가 수신되었습니다',
    },
    receipt: {
        generation: '영수증 생성 중',
        wait: '시간이 조금 걸릴 수 있습니다. 잠시만 기다려 주세요.'
    },
    blocked: {
        title: '접속이 제한되었습니다',
        ip: '귀하의 지역에서는 사이트 접근이 제한되어 있습니다. 불편을 끼쳐 드려 죄송하며, 양해해 주셔서 감사합니다.'
    },
}

export default {
    translation,
}
